<div class="bdn-modal">

  <!-- ================= VALIDATION ERROR ================= -->

  <div *ngIf="showValidationErrors" class="validation-popup">

    <div class="validation-box">

      <div class="validation-header">
        <span class="error-icon">⚠</span>
        <h3>Validation Errors</h3>
      </div>

      <div class="error-container">

        <div class="error-item" *ngFor="let err of validationErrors">
          {{ err }}
        </div>

      </div>

      <div class="error-buttons">

        <button class="submit-btn" (click)="downloadErrorFile()">
          Download Error File
        </button>

        <button class="submit-btn" (click)="closeErrorPopup()">
          OK
        </button>

      </div>

    </div>

  </div>

  <!-- ================= MAIN CONTENT ================= -->

  <ng-container *ngIf="!showValidationErrors">

    <div class="bdn-header">
      <h2>Upload Excel</h2>
      <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
    </div>

    <!-- LOADER -->

    <div *ngIf="isUploading" class="processing-box">

      <p>Processing request...</p>

      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>

    </div>

    <!-- ================= NORMAL UI ================= -->

    <ng-container *ngIf="!isUploading">

      <!-- ================= EXCEL UPLOAD ================= -->

      <div class="upload-section">

        <div class="upload-box">

          <mat-icon class="upload-icon">cloud_upload</mat-icon>

          <h3>Upload Excel File</h3>
          <p>Only Excel files allowed (.xlsx)</p>

          <input #excelFileInput type="file" hidden accept=".xlsx,.xls" (change)="uploadExcel($event)" />

          <button type="button" class="upload-btn" (click)="excelFileInput.click()">
            Upload Excel
          </button>

        </div>

      </div>


      <!-- ================= DOWNLOAD REPORT ================= -->

      <div class="bdn-table-wrapper" [formGroup]="searchForm">

        <h3 class="section-title"> Download Excel</h3>

        <div class="bdn-form-container">

          <div class="form-row">
            <label>Vessel Name</label>

            <select formControlName="vesselName" (change)="onVesselChange()">

              <option value="">Select Vessel</option>

              <option *ngFor="let vessel of vesselList" [value]="vessel.vesselIMO">

                {{ vessel.vesselName }}

              </option>

            </select>

          </div>


          <div class="form-row">

            <label>Vessel IMO</label>

            <input type="text" formControlName="imo" readonly>

          </div>


          <div class="form-row">

            <label>Start Event</label>

            <select formControlName="startEvent" (change)="onStartEventChange()">

              <option value="">Select Start Event</option>

              <option *ngFor="let event of eventList; let i = index" [value]="i">

                {{ event.eventsList }} - {{ event.report_timestamp | date:'dd-MMM-yyyy HH:mm:ss':'UTC' }}

              </option>

            </select>

          </div>


          <div class="form-row">

            <label>End Event</label>

            <select formControlName="endEvent">

              <option value="">Select End Event</option>

              <option *ngFor="let event of eventList; let i = index" [value]="i" [disabled]="i >= selectedStartIndex">

                {{ event.eventsList }} - {{ event.report_timestamp | date:'dd-MMM-yyyy HH:mm:ss':'UTC' }}

              </option>

            </select>

          </div>


          <div class="form-row">

            <label>Report Type</label>

            <select formControlName="reportType">

              <option value="">Select Report Type</option>

              <option value="atSea">At Sea</option>

              <option value="inPort">In Port</option>

            </select>

          </div>
          <div class="form-row">

            <label>Purpose</label>

            <select formControlName="purpose">

              <option value="">Select Purpose</option>
              <option value="master">Error Report</option>
              <option value="report">Report Generation</option>

            </select>

          </div>
        </div>


        <div class="bdn-footer">

          <button type="button" class="submit-btn" (click)="submitSearch()" [disabled]="searchForm.invalid">

            Submit

          </button>

        </div>

        <br>

      </div>

    </ng-container>

  </ng-container>

</div>